import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import SEOHead from './SEOHead';
import { Home, ArrowLeft, Phone, Search } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found | King of IT"
        description="The page you're looking for doesn't exist or has been moved. Return to King of IT homepage for IT support services in Toronto."
        path="/404"
        noindex={true}
      />

      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-br from-background to-muted/30 px-4">
        <div className="text-center max-w-lg">
          {/* 404 Number */}
          <div className="mb-8">
            <span className="text-8xl sm:text-9xl font-display font-bold text-gradient-gold">
              404
            </span>
          </div>

          {/* Message */}
          <h1 className="font-display font-bold text-2xl sm:text-3xl text-foreground mb-4">
            Page Not Found
          </h1>
          <p className="text-muted-foreground mb-8">
            The page you are looking for does not exist or has been moved. 
            Do not worry — let us get you back on track.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Link to="/">
              <Button className="w-full sm:w-auto bg-gradient-gold text-primary-foreground font-semibold shadow-gold hover:opacity-90">
                <Home className="w-4 h-4 mr-2" />
                Go to Homepage
              </Button>
            </Link>
            <Link to="/services">
              <Button variant="outline" className="w-full sm:w-auto">
                <Search className="w-4 h-4 mr-2" />
                View Services
              </Button>
            </Link>
          </div>

          {/* Help Text */}
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Looking for IT support in Toronto?</p>
            <a 
              href="tel:6479513653" 
              className="inline-flex items-center text-primary hover:underline font-medium"
            >
              <Phone className="w-4 h-4 mr-1" />
              Call 647-951-3653
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
